import React, { useMemo, useState } from "react";
import { Account, RentabloBankConnectionTypeEnum } from "@api";
import { buildOptions } from "./buildOptions";
import { SelectContraAccountContainer } from "./SelectContraAccountContainer";

export type IdType = "REMOTE" | "LOCAL";

export interface CurrentDepot {
  accountNumber?: string;
  iban?: string;
  name?: string;
  bankConnectionId?: number;
  bankConnectionType: RentabloBankConnectionTypeEnum;
  bankImage?: string;
  bankName?: string;
}

interface Props {
  currentDepot: CurrentDepot;
  idType: IdType;
  onSubmit: (id?: number) => void;
  isFetching?: boolean;
  showNoAccountOption?: boolean;
  defaultId?: number;
  accounts: Account[];
}

export const SelectContraAccount = ({
  currentDepot,
  idType,
  onSubmit,
  showNoAccountOption = true,
  isFetching = false,
  defaultId,
  accounts,
}: Props) => {
  const [showAllAccounts, setShowAllAccounts] = useState(false);

  const accountsToShow = showAllAccounts
    ? accounts
    : accounts.filter(
        ({ bankConnectionId }) =>
          bankConnectionId === currentDepot.bankConnectionId
      );
  const options = buildOptions(accountsToShow, idType);

  const handleShowAccountsClicked = () => {
    setShowAllAccounts((current) => !current);
  };
  const shouldShowShowAccountsButton = useMemo(() => {
    return accounts.length > accountsToShow.length;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accounts]);

  return (
    <SelectContraAccountContainer
      currentDepot={currentDepot}
      options={options}
      showAccountsFromAllBanks={showAllAccounts}
      onShowAccountsClicked={
        shouldShowShowAccountsButton ? handleShowAccountsClicked : undefined
      }
      onSubmit={onSubmit}
      showNoAccountOption={showNoAccountOption}
      isFetching={isFetching}
      defaultId={defaultId}
    />
  );
};
